import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'

const MonedaContext = createContext({})

export function MonedaProvider({ children }) {
  const { perfil } = useAuth()
  const [tipoCambio, setTipoCambio] = useState(900) // fallback CLP/USD
  const [cargandoTipo, setCargandoTipo] = useState(false)

  const moneda = perfil?.moneda || 'CLP'

  useEffect(() => {
    if (moneda === 'USD') obtenerTipoCambio()
  }, [moneda])

  const obtenerTipoCambio = async () => {
    setCargandoTipo(true)
    try {
      const res = await fetch('https://mindicador.cl/api/dolar')
      const data = await res.json()
      const valor = data?.serie?.[0]?.valor
      if (valor) setTipoCambio(valor)
    } catch (err) {
      console.error('No se pudo obtener tipo de cambio, usando fallback', err)
    } finally {
      setCargandoTipo(false)
    }
  }

  const formatearMoneda = (valorCLP) => {
    if (moneda === 'USD') {
      const usd = valorCLP / tipoCambio
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(usd)
    }
    // CLP sin decimales
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(valorCLP)
  }

  return (
    <MonedaContext.Provider value={{ moneda, tipoCambio, formatearMoneda, cargandoTipo }}>
      {children}
    </MonedaContext.Provider>
  )
}

export const useMoneda = () => useContext(MonedaContext)